var _desc, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopBarProfiloOver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "top_bar-profilo-over") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9686354,21.5314697 C8.60301257,21.5314697 5.62783543,19.8082697 3.89105829,17.1965211 C3.93151543,14.5174354 9.27610971,13.0500069 11.9686354,13.0500069 C14.6477211,13.0500069 20.0057554,14.5174354 20.0462126,17.1965211 C18.3094354,19.8082697 15.3342583,21.5314697 11.9686354,21.5314697",
    id: "Fill-4",
    fill: "#32323a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9933211,2.77482514 C14.2314926,2.77482514 16.0380754,4.58154514 16.0380754,6.81957943 C16.0380754,9.05775086 14.2314926,10.8644709 11.9933211,10.8644709 C9.75514971,10.8644709 7.94856686,9.05775086 7.94856686,6.81957943 C7.94856686,4.58154514 9.75514971,2.77482514 11.9933211,2.77482514",
    id: "Fill-6",
    fill: "#32323a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopBarProfiloOver);
export default __webpack_public_path__ + "static/media/top_bar-profilo-over.953bafd5a3be68bba55e040f04499918.svg";
export { ForwardRef as ReactComponent };